// src/hooks/products/useForceDeleteAllProducts.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllProducts } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useForceDeleteAllProducts = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllProductsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteAllProducts,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete products");
        },
    });

    return {
        forceDeleteAllProducts: forceDeleteAllProductsMutate,
        isForceDeleteAll: isPending || isLoading,
    };
};

export default useForceDeleteAllProducts;
